export default [
    {
      path: '/rent/v2/discover/travelNoteDetail',
      name: 'travelNoteDetail',
      component: () => import('@/pages/discover/travelNoteDetail'),
      meta: { title: '游记详情'},
    }
]


// WEBPACK FOOTER //
// ./src/pages/discover/discover.js